import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { LoadingIndicator } from '.';
export const LineButton = (props) => {
    const { classObject, loading, disabled } = props;
    const onClick = (event) => {
        if (disabled)
            return;
        props.onClick && props.onClick(event);
    };
    return (React.createElement("div", { className: css(styles.container, classObject), onClick: onClick }, loading ? (React.createElement(LoadingIndicator, { size: 28, isWhite: true })) : (React.createElement(React.Fragment, null,
        React.createElement("img", { className: css(styles.lineIcon), src: "/assets/images/icons/line/typeB.png" }),
        " ",
        props.children))));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.Line,
        color: Colors.White,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        height: 48,
        borderRadius: 100,
        cursor: 'pointer',
    },
    lineIcon: {
        marginRight: 7,
        width: 18,
    },
});
